<template>
  <ButtonPrime
    :label="buttonLabel"
    :icon="buttonIcon"
    :class="buttonClass"
    :loading="isLoading"
    @click="toggleVigencia"
    size="small"
  />
</template>

<script>
import MatrizService from '@/services/MatrizService';
import ButtonPrime from 'primevue/button';

export default {
  name: 'ToggleVigenciaButton',
  components: {
    ButtonPrime
  },
  props: {
    idCapitulo: { type: Number, required: true },
    usuarioId: { type: Number, required: true }
  },
  data() {
    return {
      isLoading: false,
      processStatus: null,
      chapterVigente: null
    };
  },
  computed: {
    buttonLabel() {
      if (this.isLoading) return 'Actualizando...';
      if (this.processStatus === 'success') return this.chapterVigente ? 'Activada' : 'Desactivada';
      if (this.processStatus === 'error') return 'Error';
      return this.chapterVigente ? 'Activar' : 'Desactivar'; // Cambiado de "Activar Vigencia" a solo "Activar/Desactivar"
    },
    buttonIcon() {
      if (this.isLoading) return 'pi pi-spin pi-spinner';
      if (this.processStatus === 'success') return 'pi pi-check';
      if (this.processStatus === 'error') return 'pi pi-times';
      return this.chapterVigente ? 'pi pi-ban' : 'pi pi-check-circle';
    },
    buttonClass() {
      if (this.isLoading) return 'p-button-info';
      if (this.processStatus === 'success') return 'p-button-success';
      if (this.processStatus === 'error') return 'p-button-danger';
      return this.chapterVigente ? 'p-button-danger' : 'p-button-danger'; // Rojo cuando vigente, verde cuando no
    },
    isDisabled() {
      return this.isLoading || this.chapterVigente === null;
    }
  },
  methods: {
    async toggleVigencia() {
      console.log('Iniciando alternancia de vigencia con parámetros:', {
        idCapitulo: this.idCapitulo,
        usuarioId: this.usuarioId
      });

      this.isLoading = true;
      this.processStatus = null;

      try {
        const payload = {
          IdCapitulo: this.idCapitulo,
          UsuarioId: this.usuarioId,
          Vigente: this.chapterVigente ? 0 : 1
        };

        console.log('Enviando solicitud al endpoint /api/v2/chapters/toggle-vigencia con payload:', payload);

        const response = await MatrizService.toggleChapterVigencia(payload);

        console.log('Respuesta del backend (toggle vigencia):', response);

        if (response.data.Message.includes("Vigencia actualizada")) {
          this.processStatus = 'success';
          this.chapterVigente = !this.chapterVigente;
          this.$emit('vigencia-toggled', {
            idCapitulo: this.idCapitulo,
            vigente: this.chapterVigente,
            message: response.data.Message
          });
        } else {
          this.processStatus = 'error';
          this.$emit('vigencia-error', 'Respuesta inesperada del servidor');
        }
      } catch (error) {
        console.error('Error al alternar vigencia:', error);
        const errorMsg = error.response?.data?.Message || error.response?.data || 'Error desconocido al alternar vigencia';
        this.processStatus = 'error';
        this.$emit('vigencia-error', errorMsg);
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          this.processStatus = null;
        }, 3000);
      }
    },

    async fetchChapterVigencia() {
      try {
        console.log('Obteniendo estado inicial de vigencia para idCapitulo:', this.idCapitulo);
        const response = await MatrizService.getChapterVigencia(this.idCapitulo);
        this.chapterVigente = response.vigente === 1;
        console.log('Vigencia inicial obtenida:', this.chapterVigente);
      } catch (error) {
        console.error('Error al obtener vigencia inicial:', error);
        this.chapterVigente = null;
        this.$emit('vigencia-error', 'No se pudo obtener el estado inicial de la vigencia');
      }
    }
  },
  mounted() {
    this.fetchChapterVigencia();
  }
};
</script>

<style scoped>
.p-button {
  font-size: 0.85rem;
  padding: 0.4rem 0.8rem;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.p-button.p-button-success {
  background-color: #28a745;
  border-color: #28a745;
}

.p-button.p-button-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}

.p-button.p-button-info {
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.p-button:hover {
  transform: translateY(-2px);
}
</style>